var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"display":"flex"},attrs:{"justify-center":""}},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"pulse pulse1"}),_c('div',{staticClass:"pulse pulse2"}),_c('div',{staticClass:"pulse pulse3"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }